<template>
    <div class="orderLine">

        <div class="map-container">
            <div id="order-map"></div>

            <div class="map-left-top">
                <div class="map-left-top-item" @click="showMarker">
                    <div class="left-top-item-btn blue">起</div>
                    <div class="left-top-item-line"></div>
                    <div class="left-top-item-btn green">终</div>
                </div>
                <div class="map-left-top-item" @click="showLine" v-if="rowData.status > 10">
                    <div class="left-top-item-btn blue" data-type="connect">接</div>
                    <div class="left-top-item-line"></div>
                    <div class="left-top-item-btn blue" data-type="upper">上</div>
                    <div class="left-top-item-line"></div>
                    <div class="left-top-item-btn green" data-type="below">下</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "orderLineTab",
    props: {
        rowData: {
            required: true,
            type: Object,
            default: () => {
                return null;
            },
        },
    },
    data() {
        return {
            map: null,
            trackList: [], //轨迹点
            startMarker: null,
            endMarker: null,
            upperMarker: null,
            belowMarker: null,
            connectMarker: null,
            startLine: null,
            endLine: null,
            infoWindow: null,
        };
    },
    watch: {
        rowData: {
            handler(val) {
                if (!val.id) return

                this.$nextTick(() => {
                    this.getTrackFn();
                    this.initMap()
                })
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        /**
         * 清理所有地图实例
         */
        destroyMapInstances() {
            // 清理标记点
            const markers = ['start', 'end', 'upper', 'below', 'connect'];
            markers.forEach(marker => {
                if (this[marker + 'Marker']) {
                    this[marker + 'Marker'].setMap(null);
                    this[marker + 'Marker'] = null;
                }
            });

            // 清理路线
            const lines = ['startLine', 'endLine'];
            lines.forEach(line => {
                if (this[line]) {
                    this[line].setData([]);
                    if (this[line].destroy) {
                        this[line].destroy();
                    }
                    this[line] = null;
                }
            });

            // 清理信息窗体
            if (this.infoWindow) {
                this.infoWindow.close();
                this.infoWindow = null;
            }

            // 清理地图
            if (this.map) {
                this.map.destroy();
                this.map = null;
            }
        },
        /**
         * 绘制路线
         */
        drawPolyline(lineList) {
            if (this[lineList.name]) {
                // 正确清理已存在的 PathSimplifier 实例
                this[lineList.name].setData([]); // 清除数据
                if (this[lineList.name].destroy) {
                    this[lineList.name].destroy();
                }
                this[lineList.name] = null;
            }

            let that = this
            AMapUI.loadUI(['misc/PathSimplifier'], function (PathSimplifier) {
                if (!PathSimplifier.supportCanvas) {
                    alert('当前环境不支持 Canvas！');
                    return;
                }

                // 创建PathSimplifier对象
                that[lineList.name] = new PathSimplifier({
                    zIndex: 99,
                    map: that.map, // 所属的地图实例
                    getPath: function (pathData, pathIndex) {
                        return pathData.path;
                    },
                    getHoverTitle: function (pathData, pathIndex, pointIndex) {
                        return pathData.name;
                    },
                    renderOptions: {
                        pathLineStyle: {
                            lineWidth: 8, // 设置线路宽度
                            dirArrowStyle: true // 启用方向箭头
                        },
                        getPathStyle: (pathItem, zoom) => {
                            return {
                                pathLineStyle: {
                                    strokeStyle: pathItem.pathData.color,
                                    dirArrowStyle: true // 启用方向箭头
                                },
                            }
                        },
                        pathNavigatorStyle: {
                            pathLinePassedStyle: {
                                lineWidth: 8,
                                strokeStyle: '#2B77FF'
                            }
                        }
                    }
                });

                // 设置数据
                that[lineList.name].setData(lineList.line);
            });
        },
        // 绘制点
        drawPointMarker(markers) {
            markers.forEach((item, index) => {
                if (this[item.name + 'Marker']) {
                    // 如果标记已存在，先从地图上移除
                    this[item.name + 'Marker'].setMap(null);
                    this[item.name + 'Marker'] = null;
                }
                this[item.name + 'Marker'] = new AMap.Marker({
                    position: new AMap.LngLat(item.marker.lng, item.marker.lat),
                    // icon: item.marker.icon,
                    icon: new AMap.Icon({ // 设置标记的图标
                        size: new AMap.Size(34, 40),
                        image: item.marker.icon,
                        imageSize: new AMap.Size(34, 40),
                        zIndex: 10000
                    }),
                    map: this.map,
                    offset: new AMap.Pixel(-17, -20),
                    title: '', // 设置为空以移除默认的title提示
                    cursor: 'pointer', // 设置鼠标样式
                    zIndex: 10000 // 将zIndex设置为更高的值，确保在PathSimplifier上方显示

                })
                if (item.name === 'start' || item.name === 'end') {
                    this[item.name + 'Marker'].on('click', () => {
                        this.showLabel(item.marker)
                    })

                    // 使用mouseover代替mouseenter
                    this[item.name + 'Marker'].on('mouseover', () => {
                        this.showLabel(item.marker)
                    })

                    // 使用mouseout代替mouseleave
                    this[item.name + 'Marker'].on('mouseout', () => {
                        if (this.infoWindow) {
                            this.infoWindow.close();
                        }
                    })
                }
            })
        },

        showLabel(marker) {
            // 如果已存在信息窗体，先关闭
            if (this.infoWindow) {
                this.infoWindow.close();
            }

            // 创建信息窗体
            this.infoWindow = new AMap.InfoWindow({
                content: `<div style="padding: 8px; background-color: #fff; border-radius: 4px; font-size: 14px;">${marker.name || ''}</div>`,
                offset: new AMap.Pixel(0, -25),
                closeWhenClickMap: true, // 点击地图其他区域时关闭
                autoMove: true, // 自动调整窗体到视野内
                isCustom: true, // 使用自定义窗体
            });

            // 在marker位置打开信息窗体
            this.infoWindow.open(this.map, [marker.lng, marker.lat]);
        },

        // 绘制起始点
        drawStartPoint() {
            // 乘客出发点
            let startInfo = {
                lng: this.rowData.startPointLng,
                lat: this.rowData.startPointLat,
                name: this.rowData.startPointName,
                icon: require("@/assets/img/point_start_2x.png"),
            };
            // 乘客目的点
            let endInfo = {
                lng: this.rowData.endPointLng,
                lat: this.rowData.endPointLat,
                name: this.rowData.endPointName,
                icon: require("@/assets/img/point_end_2x.png"),
            }

            let points = [
                {
                    name: 'start',
                    marker: startInfo
                },
                {
                    name: 'end',
                    marker: endInfo
                }
            ]
            this.drawPointMarker(points)

        },

        // 绘制线路点
        drawLinePoint(pointList = ['connect', 'upper', 'below']) {
            const connectPoint = this.trackList.find(item => item.status === 20)
            const upperPoint = this.trackList.find(item => item.status === 40)
            const belowPoint = this.trackList[this.trackList.length - 1]
            // 接人点
            let connectInfo = {
                lng: connectPoint?.longitude,
                lat: connectPoint?.latitude,
                icon: require("@/assets/img/point_connect_2x.png"),
            }
            //乘客上车点
            let upperInfo = {
                lng: upperPoint?.longitude,
                lat: upperPoint?.latitude,
                icon: require("@/assets/img/point_shang_2x.png"),
            }
            //乘客下车点
            let belowInfo = {
                lng: belowPoint?.longitude,
                lat: belowPoint?.latitude,
                icon: this.rowData.status == 45 ? require("@/assets/img/point_xia_2x.png") : require("@/assets/img/point_car_2x.png"),
            }
            let points = []
            if (upperInfo.lng && upperInfo.lat && pointList.includes('upper')) {
                points.push({
                    name: 'upper',
                    marker: upperInfo
                })
            }
            if (belowInfo.lng && belowInfo.lat && pointList.includes('below')) {
                points.push({
                    name: 'below',
                    marker: belowInfo
                })
            }
            if (connectInfo.lng && connectInfo.lat && pointList.includes('connect')) {
                points.push({
                    name: 'connect',
                    marker: connectInfo
                })
            }
            this.drawPointMarker(points)
        },
        // 绘制开始接人到乘客上车点线路
        drawStartLine() {
            let points = this.trackList.filter(item => item.status >= 20 && item.status < 40).map(item => [item.longitude, item.latitude])
            let lineList = [{
                name: '',
                path: points,
                color: '#2B77FF'
            }]
            this.drawPolyline({
                name: 'startLine',
                line: lineList
            })
        },

        // 绘制乘客上车点到乘客下车点线路
        drawEndLine() {
            let points = this.trackList.filter(item => item.status == 40).map(item => [item.longitude, item.latitude])
            let lineList = [{
                name: '',
                path: points,
                color: '#67C23A'
            }]
            this.drawPolyline({
                name: 'endLine',
                line: lineList
            })
        },

        showMarker() {
            this.drawStartPoint()
            setTimeout(() => {
                this.map.setFitView([this.startMarker, this.endMarker], [60, 60, 60, 60])
            }, 100)
        },
        showLine(e) {
            const type = e.target.dataset.type

            // 清除路线 
            if (this.startLine) {
                this.startLine.setData([]); // 清除数据
                if (this.startLine.destroy) {
                    this.startLine.destroy();
                }
                this.startLine = null;
            }

            if (this.endLine) {
                this.endLine.setData([]); // 清除数据
                if (this.endLine.destroy) {
                    this.endLine.destroy();
                }
                this.endLine = null;
            }

            // 清除标记点
            this.upperMarker && this.upperMarker.setMap(null);
            this.belowMarker && this.belowMarker.setMap(null);
            this.connectMarker && this.connectMarker.setMap(null);

            this.drawLinePoint();
            this.drawStartLine();
            this.drawEndLine();
            setTimeout(() => {
                if (type === 'connect') {
                    let overlays = [];
                    if (this.connectMarker) overlays.push(this.connectMarker);
                    if (this.upperMarker) overlays.push(this.upperMarker);
                    this.map.setFitView(overlays, false, [80, 80, 80, 80]);
                } else if (type === 'below') {
                    let overlays = [];
                    if (this.connectMarker) overlays.push(this.connectMarker);
                    if (this.upperMarker) overlays.push(this.upperMarker);
                    if (this.belowMarker) overlays.push(this.belowMarker);
                    this.map.setFitView(overlays, false, [80, 80, 80, 80])
                } else {
                    let overlays = [];
                    if (this.upperMarker) overlays.push(this.upperMarker);
                    if (this.belowMarker) overlays.push(this.belowMarker);
                    this.map.setFitView(overlays, false, [80, 80, 80, 80])
                }
            }, 100);

        },
        /**
         * 初始化地图
         */
        initMap() {
            this.map = new AMap.Map("order-map", {
                viewMode: '2D', // 默认使用3D地图
                resizeEnable: true,
                animateEnable: true,
                zoom: 18,
                center: new AMap.LngLat(104.065861, 30.657401),
                mapStyle: 'amap://styles/117929a1925007df896212a1031807f5'
            });
        },


        // 获取轨迹
        async getTrackFn() {
            const url = '/api/v1/manage/order/hitchRide/location'
            const { data, code } = await this.$axios.get(url, { id: this.rowData.id })
            if (code === 1 && data) {
                this.trackList = data;
                // 先绘制所有点和线路
                this.drawStartPoint();

                let showMarkers = ['start', 'end']
                if (this.rowData.status > 10) {
                    this.drawLinePoint();
                }
                if (data.filter(item => item.status == 20).length > 0) {
                    this.drawStartLine();
                    showMarkers.push('connect')
                    showMarkers.push('below')
                }
                if (data.filter(item => item.status == 40).length > 0) {
                    this.drawEndLine();
                    showMarkers.push('upper')
                }
                let mapMarker = showMarkers.map(item => this[item + 'Marker'])
                setTimeout(() => {
                    this.map.setFitView(mapMarker, false, [60, 60, 60, 60])
                }, 200)
            }
        },
    },
    beforeDestroy() {
        // 清理所有地图实例
        this.destroyMapInstances();
    },
};
</script>

<style lang="less" scoped>
.orderLine {
    width: 100%;
    height: 100%;
    .map-container {
        width: 100%;
        height: 100%;
        position: relative;

        .map-left-top {
            position: absolute;
            top: 10px;
            left: 10px;
            z-index: 100;
            border-radius: 5px;

            .map-left-top-item {
                padding: 10px;
                background-color: #fff;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;
                border-radius: 10px;
                overflow: hidden;
                box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

                .left-top-item-btn {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #fff;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                .blue {
                    background-color: #2B77FF;
                }

                .green {
                    background-color: #67C23A;
                }

                .left-top-item-line {
                    width: 2px;
                    height: 20px;
                    background-color: #E8E8E8;
                }
            }

        }
    }

    #order-map {
        width: 100%;
        height: 100%;
    }

    .map-controls {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 100;
    }

    .map-toggle-btn {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    .formContent {
        display: flex;
        flex-wrap: wrap;

        .items {
            width: 48%;
            margin-right: 1%;
            word-wrap: break-word;
            /* 旧版浏览器支持 */
            overflow-wrap: break-word;
            /* 标准属性 */
        }
    }
}
</style>